import { render, staticRenderFns } from "./HeaderUserArea.vue?vue&type=template&id=31c134d3&scoped=true&"
import script from "./HeaderUserArea.vue?vue&type=script&lang=js&"
export * from "./HeaderUserArea.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUserArea.vue?vue&type=style&index=0&id=31c134d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c134d3",
  null
  
)

export default component.exports